  // Get all elements with the specified class
var megamenuContent = document.querySelectorAll('.mega-menu__content');
var ulElements = document.querySelectorAll('.mega-menu__list');
var targetElements = document.querySelectorAll('.megamenu-image-block-with-text-venus-by-qode-space');

function updateMegaMenuLists(){
  ulElements.forEach(ul => {
    if (ul.querySelector('.image_container_megamenu_venus')) {
      ul.classList.add('tw-flex', 'tw-flex-row', 'tw-gap-10', 'tw-flex-nowrap', 'tw-justify-center');
    }
  });

  megamenuContent.forEach(content => {
    const targetChild = content.querySelector('.megamenu-image-block-with-text-venus-by-qode-space');
    if (targetChild) {
      const contentContainer = content.querySelector('.megamenu__content-container');
      if (contentContainer) {
        // Limpiar posibles configuraciones previas de grid para evitar conflictos
        contentContainer.classList.remove(
          'tw-grid-cols-[auto_minmax(0,_600px)]',
          'tw-grid-cols-[.5fr_2fr]',
          'tw-grid-cols-[2fr_.5fr]',
          'tw-grid-cols-[1fr_2fr]',
          'tw-grid-cols-[2fr_1fr]'
        );

        const secondImage = contentContainer.querySelector('.second_image');
        const firstImage = contentContainer.querySelector('.first_image');

        // Determinar si el bloque de imágenes está a la derecha o a la izquierda
        const imagesRightSide = contentContainer.querySelector('.megamenu-images-right-side');

        if (secondImage) {
          // Dos imágenes: enlaces 2fr, imágenes 1fr
          // Si las imágenes están a la derecha, el DOM suele ser: UL (enlaces) luego contenedor de imágenes.
          // Si están a la izquierda, el DOM suele ser: contenedor de imágenes luego UL.
          if (imagesRightSide) {
            // Orden: [enlaces, imágenes]
            contentContainer.classList.add('tw-grid', 'tw-grid-cols-[2fr_1fr]', 'tw-gap-10', 'tw-justify-items-start');
          } else {
            // Orden: [imágenes, enlaces]
            contentContainer.classList.add('tw-grid', 'tw-grid-cols-[1fr_2fr]', 'tw-gap-10', 'tw-justify-items-start');
          }
        } else {
          // Una sola imagen: enlaces 2fr, imagen .5fr
          if (firstImage) {
            // La card de imagen debe usar todo el ancho disponible de su columna
            firstImage.classList.remove('tw-w-1/3');
            firstImage.classList.add('tw-w-full');
          }

          if (imagesRightSide) {
            // Orden: [enlaces, imagen]
            contentContainer.classList.add('tw-grid', 'tw-grid-cols-[2fr_.5fr]', 'tw-gap-10', 'tw-justify-items-start');
          } else {
            // Orden: [imagen, enlaces]
            contentContainer.classList.add('tw-grid', 'tw-grid-cols-[.5fr_2fr]', 'tw-gap-10', 'tw-justify-items-start');
          }
        }
      }
    }
  });

  // Ajustar margen del UL cuando existe bloque de imagen
  targetElements.forEach(target => {
    const parent = target.parentElement;
    if (!parent) return;

    const siblingUl = parent.querySelector('.mega-menu__list');
    if (siblingUl) {
      siblingUl.classList.add('tw-ml-0');
    }
  });
}

document.addEventListener('DOMContentLoaded', () => {
  updateMegaMenuLists();
});

if (Shopify.designMode) {
  updateMegaMenuLists();
}